import React from 'react'

import { PaginatedTable, PaginatedTableCallbacks, useTableUrlSync } from '../common'
import { PaymentFilters } from './filters'
import { PaymentsTable } from './table'
import { JsonRecord, Record } from '../../models'
import { getPaidRecords } from '../../api'
import { downloadPaymentsCsv } from '../../api/routes'
import { getAuthUser } from '../../helpers'
import { currencyFormat } from '../../helpers/currencyCalculation'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../common'

export const PaymentsReport = () => {
    const ability = defineAbilityFor(getAuthUser())
    const tableUrlSync = useTableUrlSync([
        'payment_method_id',
        'record_status_code',
        'record_substatus_code',
        'date_paid_from',
        'date_paid_to',
        'check_number',
    ])

    if (!ability.can('View', 'PaymentReport')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<Record, JsonRecord>
            defaultFilters={tableUrlSync.defaultFilters}
            defaultSearch={tableUrlSync.defaultSearch}
            defaultPage={tableUrlSync.defaultPage}
            DownloadButton={({ params }) => (
                <a
                    href={downloadPaymentsCsv + '?' + new URLSearchParams(params).toString()}
                    className="btn btn-primary"
                >
                    Download CSV
                </a>
            )}
            getData={(params) =>
                getPaidRecords({
                    ...params,
                    ...(tableUrlSync.sortBy ? { sortBy: tableUrlSync.sortBy } : {}),
                    ...(tableUrlSync.sortDirection
                        ? { sortDirection: tableUrlSync.sortDirection }
                        : {}),
                })
            }
            Filters={PaymentFilters}
            formatHeaderData={(total: string) => {
                return `Total: ${currencyFormat(+total)}`
            }}
            modelConstructor={(json: JsonRecord) => new Record(json)}
            onParamsChange={tableUrlSync.onParamsChange}
            persistSearch={tableUrlSync.persistSearch}
            searchPlaceholder="REC, Conf, Last Name, Phone, Supplier, or AGENCY"
            Table={(records: Record[], callbacks: PaginatedTableCallbacks) => (
                <PaymentsTable callbacks={callbacks} resources={{ records }} />
            )}
            title="Payments"
        />
    )
}
